export const prepareBlockFilters = (block) => {
  const blockFilter = block.filter.split('-')[0]
  const filters = {}

  if (blockFilter === 'featured') {
    filters.featured = 1
  }

  if (blockFilter === 'withoutfeatured') {
    filters.featured = 0
  }

  if (blockFilter === 'custom') {
    filters['ids'] = block.items.map(item => item.id).join(',')
  }

  return filters
}

export const prepareBlockSorts = (block) => {
  const blockSort = block.filter.split('-')[1]

  if (blockSort === 'createdAt') {
    return '-createdAt'
  }

  if (blockSort === 'updatedAt') {
    return '-updatedAt'
  }

  return ''
}
